import React from 'react';
import { Section } from './ui/Section';
export function About() {
  return <Section id="about" background="white" data-id="element-1">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-center" data-id="element-2">
        <div data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-4">
            Effizienz schaffen. <br data-id="element-5" />
            Vertrieb neu denken.
          </h2>
          <div className="w-20 h-1 bg-emerald-600 mb-8" data-id="element-6"></div>
          <div className="space-y-6 text-lg text-slate-600 leading-relaxed" data-id="element-7">
            <p data-id="element-8">
              KZEV steht für strategische Klarheit, technologische Kompetenz und
              messbare Ergebnisse im Vertrieb.
            </p>
            <p data-id="element-9">
              Als Kompetenzzentrum begleiten wir Unternehmen bei der
              Neuausrichtung, Digitalisierung und Skalierung ihrer
              Vertriebsmodelle. Wir glauben nicht an theoretische Konzepte, die
              in der Schublade landen, sondern an operative Exzellenz, die sich
              in Ihren Zahlen widerspiegelt.
            </p>
          </div>
        </div>

        <div className="relative" data-id="element-10">
          <div className="aspect-[4/3] bg-slate-100 rounded-sm overflow-hidden relative z-10" data-id="element-11">
            {/* Abstract representation of structure/clarity */}
            <div className="absolute inset-0 bg-slate-900 p-8 flex flex-col justify-between" data-id="element-12">
              <div className="grid grid-cols-2 gap-4 opacity-20" data-id="element-13">
                <div className="h-2 bg-white rounded-full w-3/4" data-id="element-14"></div>
                <div className="h-2 bg-white rounded-full w-1/2" data-id="element-15"></div>
                <div className="h-2 bg-white rounded-full w-full" data-id="element-16"></div>
                <div className="h-2 bg-white rounded-full w-2/3" data-id="element-17"></div>
              </div>

              <div className="space-y-4" data-id="element-18">
                <div className="flex items-center justify-between text-white/90 border-b border-white/10 pb-4" data-id="element-19">
                  <span className="font-medium" data-id="element-20">Effizienzsteigerung</span>
                  <span className="font-bold text-emerald-400" data-id="element-21">+35%</span>
                </div>
                <div className="flex items-center justify-between text-white/90 border-b border-white/10 pb-4" data-id="element-22">
                  <span className="font-medium" data-id="element-23">Lead-Qualität</span>
                  <span className="font-bold text-emerald-400" data-id="element-24">+50%</span>
                </div>
                <div className="flex items-center justify-between text-white/90" data-id="element-25">
                  <span className="font-medium" data-id="element-26">Prozesskosten</span>
                  <span className="font-bold text-emerald-400" data-id="element-27">-20%</span>
                </div>
              </div>
            </div>
          </div>
          {/* Decorative element */}
          <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-slate-200 z-0 rounded-sm" data-id="element-28"></div>
        </div>
      </div>
    </Section>;
}